import { LucideIcon } from 'lucide-react';

interface TextInputProps {
  id: string;
  name: string;
  type?: 'text' | 'tel' | 'email';
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  disabled?: boolean;
  required?: boolean;
  hasError?: boolean;
  icon?: LucideIcon;
}

export function TextInput({
  id,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  disabled = false,
  required = false,
  hasError = false,
  icon: Icon,
}: TextInputProps) {
  const baseClasses =
    'block w-full pr-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E34290] focus:border-[#E34290] bg-white dark:bg-gray-800 text-theme-light-text-primary dark:text-theme-dark-text-primary placeholder-theme-light-text-muted dark:placeholder-theme-dark-text-muted transition-colors';
  const iconClasses = Icon ? 'pl-10' : 'pl-3';
  const borderClasses = hasError
    ? 'border-red-300 dark:border-red-600'
    : 'border-gray-300 dark:border-gray-600';

  return (
    <div className="relative">
      {Icon && (
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Icon className="h-5 w-5 text-theme-light-text-muted dark:text-theme-dark-text-muted" />
        </div>
      )}
      <input
        id={id}
        name={name}
        type={type}
        required={required}
        className={`${baseClasses} ${iconClasses} ${borderClasses}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      />
    </div>
  );
}
